module.exports = __webpack_public_path__ + "img/privilege12.21b1c38c.png";